import React from 'react';
import TourCard from './TourCard';
import { Tour, Bundle } from '../types';

interface TourGridProps {
    bookTourFunction?: (tourNames: string[]) => void;
    tours: Tour[];
    omit?: string;
    filter?: string;
    reducedHeight?: boolean;
    bundles?: Bundle[];
}

function TourGrid({ bookTourFunction, tours, omit, filter, reducedHeight, bundles }: TourGridProps) {
    return (
        <div>
            {bundles ?
            <div className="grid-container-bundle">
                {bundles.map((bundle, bundleIndex) => (
                    <div key={bundleIndex} className="bundleRow">
                    {bundle.tours.map((bundleTour, tourIndex) => {
                        const foundTour = tours.find(desc => desc.name === bundleTour);
                        return foundTour ? (
                            <TourCard key={tourIndex} bookTourFunction={bookTourFunction} tour={foundTour} bundle={true} />
                        ) : null;
                    })}
                        <div>
                            <div></div>
                            <div>Price Per Adult: {bundle.price}</div>
                            <div>Price Per Child{bundle.priceChild}</div>
                        </div>
                    </div>
                ))}
            </div>
            :
            <div className={reducedHeight != null && reducedHeight ? "grid-container" : "grid-container maxed"}
            id="gridImages">
            {tours.map((tour, index) => (
                tour.name === omit ? null :
                filter != null && filter === "cruise" && !tour.cruise ? null :
                <TourCard key={index} tour={tour} bookTourFunction={bookTourFunction} />
            ))}
            </div>}
        </div>
    );
}

export default TourGrid;
